import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['infoNotifications']),
  },
  methods: {
    notificationsItem(key) {
      return this.infoNotifications.find((item) => item.code === key) ?? false
    },
    notificationText(key) {
      if (this.notificationsItem(key)) {
        let error = this.notificationsItem(key)
        return this.$i18n.locale === 'lt' ? error.text_lt : error.text_en
      } else {
        return false
      }
    },
  },
}
